// cm-coding: Workday cannot provide a safe interactive requisition preview.
// Show the exact ID and filter scope that the background pull will apply so
// administrators can review the bounded selection before saving instead of
// assuming that an unseen broad SOAP query will run.

import { Input, Label } from '@/components/ui'
import { ConnectorQueryLockNotice } from '../../components/ConnectorQueryLockNotice'
import type { WorkdayFilter } from '../types'
import { WorkdayFilters } from './WorkdayFilters'

export function WorkdayScope({
  filters,
  onFiltersChange,
  canEditFilters,
}: {
  filters: WorkdayFilter[]
  onFiltersChange: (filters: WorkdayFilter[]) => void
  canEditFilters: boolean
}) {
  return (
    <div className="space-y-4">
      <div className="space-y-1.5">
        <Label>Workday table</Label>
        <Input disabled value="Requisitions" className="h-10 bg-slate-50" />
        <p className="text-xs text-slate-500">Only Get_Requisitions is supported in this release.</p>
      </div>
      {!canEditFilters && <ConnectorQueryLockNotice providerLabel="Workday" />}
      <WorkdayFilters filters={filters} canEdit={canEditFilters} onChange={onFiltersChange} />
      <div className="rounded-lg border border-slate-200 bg-slate-50 px-3 py-2.5">
        <p className="text-sm font-medium text-slate-800">Specific records only</p>
        <p className="mt-0.5 text-xs leading-5 text-slate-600">
          Workday SOAP downloads every attachment with a requisition, so a live preview
          is not possible. Configuration does not query Workday. Use Manage records and
          enter requisition numbers; the background job fetches each requisition once
          and enforces these filters before import.
        </p>
      </div>
    </div>
  )
}
